import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button,Table } from "react-bootstrap";
import Card from "../../../components/Card";
import ToastNotification from "../../../components/Toast";
import { API_MODULE_LIST ,API_ACL_SETTING_EDIT} from "../../../service/url";
import { postApiCall, getApiCall } from "../../../service/httpCall";
import { useNavigate, useParams } from "react-router-dom";
import {getUser,
  getUserModules,
} from "../../../utilities/setting";
import { USER_ROLES } from '../../../utilities/constant';
import { ROUTES } from "../../../utilities/constant";
import { useAuth, errorCheck } from '../auth/auth-utils';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { FaCheck, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";

function getApiUrl(url, id){
    return url.replace(':id', id);
}

const ACLSettingEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [aclName, setACLName] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [moduleList, setModuleList] = useState([]);
  const [selectedModules, setSelectedModules] = useState({});
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modulePermission, updateModulePermission] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [defaultForRole, setDefaultForRole] = useState("");



  useEffect(() => {
    async function superadminCheck() {
      const rawUser = await AsyncStorage.getItem('user');
      if (!rawUser) {
        console.error("User not found in AsyncStorage");
        return null; // or handle as needed
      }

      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON in user from AsyncStorage", e);
        return null;
      }
      if (user?.acl_settings?.module_operations) {
        updateModulePermission(JSON.parse(user?.acl_settings?.module_operations));
      }
      if (user.role === USER_ROLES.SUPERADMIN) {
        setIsSuperAdmin(true);
      }
      setLoading(false); // Set loading to false after check
    }

    superadminCheck();
  }, []);
 
  useEffect(() => {

    const editApiUrl = getApiUrl(API_ACL_SETTING_EDIT, id);
    getApiCall(editApiUrl, {})
        .then(onGetSuccess).catch(onError);

  }, [id]);

  useEffect(() => {
    if (!loading) { // Ensure superadminCheck has completed
      getApiCall(API_MODULE_LIST, {})
        .then(onModuleListSuccess)
        .catch(onError);
    }
  }, [loading]);


  useEffect(() => {
    checkAuth(setToastProps, setShowToast)
  }, []);

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);


  function onGetSuccess(resp){
    setACLName(resp?.acl_name);
    setSelectedModules(JSON.parse(resp?.module_operations));
    setDefaultForRole(resp?.default_for_role || "");
  }
  function getKeysWithTrueValues(moduleOperations) {
    return Object.keys(moduleOperations).filter(key => {
        const permissions = moduleOperations[key];
        return Object.values(permissions).some(value => value === true);
    });
  }

  function onModuleListSuccess(resp) {
    if (isSuperAdmin) {
      setModuleList(resp)
    } else {
      getUser().then((user) => {
        if (user) {
          if (user?.acl_settings?.module_operations) {
            let modules = getKeysWithTrueValues(JSON.parse(user?.acl_settings?.module_operations));
             modules = resp.filter(item => modules.includes(item.module_name));
            setModuleList(modules);
          }
        }
      });
    }
  }

  function validateForm() {
    let valid = true;

    if (!aclName.trim()) {
      valid = false;
      // setToastProps({ message: "ACL name required", type: "danger" });
          toast.error("ACL name required");
    } 

    return valid;
  }

  const normalizePermissions = (modules) => {
    const defaultOps = ["read", "add", "edit", "delete", "view_permission"];

    const normalized = {};

    for (const module in modules) {
      normalized[module] = {};

      defaultOps.forEach(op => {
        normalized[module][op] = modules[module]?.[op] ?? false;
      });
    }

    return normalized;
  };


  async function submitForm() {
    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    let params = { 
      acl_name: aclName,
      module_operations: normalizePermissions(selectedModules),
      default_for_role: defaultForRole || null,
    };
    const editApiUrl = getApiUrl(API_ACL_SETTING_EDIT, id);
      postApiCall(editApiUrl, params)
         .then(onAClSettingUpdateSuccess)
         .catch(onAClSettingUpdateError);
}



  function onAClSettingUpdateSuccess(resp) {
    // setToastProps({ message: "ACL Setting updated successfully", type: "success" });
          toast.success("ACL Setting updated successfully");
    setTimeout(() => {
      navigate(`/${ROUTES.ACL_SETTING.LIST}`);
    }, 1500);
  }
  function onAClSettingUpdateError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
       errorCheck(err, navigate, setToastProps, setShowToast)
    } else {
      setButtonDisable(false);
      // setToastProps({message: JSON.stringify(err), type: 'danger'});
          toast.error(JSON.stringify(err));
    }
 }

  
  function onError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
   } else {
     setButtonDisable(false);
    //  setToastProps({message: JSON.stringify(err), type: 'danger'});
          toast.error(JSON.stringify(err));
   }
 }


  const handleCheckboxChange = (moduleName, operation) => {
    // if (isSuperAdmin || modulePermission?.[moduleName]?.[operation]) {
      setSelectedModules((prev) => {

        const updated = {
          ...prev,
          [moduleName]: {
            read: prev?.[moduleName]?.read ?? false,
            add: prev?.[moduleName]?.add ?? false,
            edit: prev?.[moduleName]?.edit ?? false,
            delete: prev?.[moduleName]?.delete ?? false,
            view_permission: prev?.[moduleName]?.view_permission ?? false,
            [operation]: !prev?.[moduleName]?.[operation]
          }
        };

        return updated;
      });

    // } else {
    //   SweetAlert({
    //     text: `Don't have Permission to add ${moduleName} ${operation} operation.`,
    //     icon: "warning",
    //     time: 2000
    //   });
    // }
  };

  
  const getCheckboxStyle = (isChecked) => ({
    backgroundColor: isChecked ? 'green' : 'red',
    width: '20px',
    height: '20px',
    display: 'inline-block',
    cursor: 'pointer',
    textAlign: 'center',
    lineHeight: '20px',
    color: 'white'
  });

  const handleSelectAllPermissions = (moduleName) => {
      setSelectedModules((prev) => {
        const current = prev[moduleName] || {};
  
        const isAllSelected =
          current.read &&
          current.add &&
          current.edit &&
          current.delete &&
          current.view_permission;
  
        return {
          ...prev,
          [moduleName]: {
            read: !isAllSelected,
            add: !isAllSelected,
            edit: !isAllSelected,
            delete: !isAllSelected,
            view_permission: !isAllSelected
          }
        };
      });
    };
  
  
    const filteredModules = moduleList
      .slice()
      .sort((a, b) =>
        a.module_name.localeCompare(b.module_name)
      )
      .filter((module) =>
        module.module_name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase())
    );

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">ACL Setting Information</h4>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="new-user-info">
                  <form>
                    <div className="row">
                      <Form.Group className="col-md-4 form-group">
                        <Form.Label htmlFor="username">ACL Name: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Control
                          type="text"
                          id="name"
                          placeholder="ACL Name"
                          value={aclName}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[A-Za-z0-9_ ]*$/.test(value)) {
                              setACLName(e.target.value);
                            }
                          }}
                        />
                      </Form.Group>

                      <Form.Group className="col-md-4 form-group">
                        <Form.Label>Default for Role (optional)</Form.Label>
                        <Form.Select
                          value={defaultForRole}
                          onChange={(e) => setDefaultForRole(e.target.value)}
                        >
                          <option value="">None</option>
                          <option value={USER_ROLES.RESELLER}>Reseller</option>
                          <option value={USER_ROLES.COMPANY_ADMIN}>Company Admin</option>
                          <option value={USER_ROLES.CALL_CENTRE_ADMIN}>Call Centre Admin</option>
                          <option value={USER_ROLES.CALL_CENTRE_AGENT}>Call Centre Agent</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                                                                            
                   <div className="header-title">
                  <h6 className="card-title">Please Select Module Operations</h6>
                   </div>
                   <Form.Group className="col-md-6 form-group mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Search module..."
                        value={searchTerm}
                        style={{ marginTop: "20px", marginBottom: "20px", width: "300px" }}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </Form.Group>
                   {moduleList.length === 0 ? (
                      <div>No modules added</div>
                    ) : (
                  <Table responsive bordered>
                  <thead>
                    <tr>
                      <th>Module Name</th>
                      <th>Read</th>
                      <th>Add</th>
                      <th>Edit</th>
                      <th>Delete</th>
                      <th>View Permission</th>
                      <th>Select / Deselect All</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredModules.map((module, index) => (
                      <tr key={index}>
                        <td>{module.module_name}</td>
                        <td>
                                                  <div
                                                    className={`permission-pill ${
                                                      selectedModules[module.module_name]?.read ? "active" : ""
                                                    }`}
                                                    onClick={() =>
                                                      handleCheckboxChange(module.module_name, "read")
                                                    }
                                                  >
                                                    <span className="pill-icon">
                                                      {selectedModules[module.module_name]?.read ? <FaCheck className="perm-icon" /> : <FaTimes className="perm-icon off" />}
                                                    </span>
                                                  </div>
                                                </td>
                                                <td>
                                                <div
                                                  className={`permission-pill read ${
                                                    selectedModules[module.module_name]?.add ? "active" : ""
                                                  }`}
                                                  onClick={() => handleCheckboxChange(module.module_name, "add")}
                                                >
                                                  <span className="pill-icon">
                                                    {selectedModules[module.module_name]?.add ? <FaCheck className="perm-icon" /> : <FaTimes className="perm-icon off" />}
                                                  </span>
                                                </div>
                                              </td>
                        
                                              <td>
                                                <div
                                                  className={`permission-pill edit ${
                                                    selectedModules[module.module_name]?.edit ? "active" : ""
                                                  }`}
                                                  onClick={() => handleCheckboxChange(module.module_name, "edit")}
                                                >
                                                  <span className="pill-icon">
                                                    {selectedModules[module.module_name]?.edit ? <FaCheck className="perm-icon" /> : <FaTimes className="perm-icon off" />}
                                                  </span>
                                                </div>
                                              </td>
                        
                                              <td>
                                                <div
                                                  className={`permission-pill delete ${
                                                    selectedModules[module.module_name]?.delete ? "active" : ""
                                                  }`}
                                                  onClick={() => handleCheckboxChange(module.module_name, "delete")}
                                                >
                                                  <span className="pill-icon">
                                                    {selectedModules[module.module_name]?.delete ? <FaCheck className="perm-icon" /> : <FaTimes className="perm-icon off" />}
                                                  </span>
                                                </div>
                                              </td>
                        
                                              <td>
                                                <div
                                                  className={`permission-pill view ${
                                                    selectedModules[module.module_name]?.view_permission ? "active" : ""
                                                  }`}
                                                  onClick={() =>
                                                    handleCheckboxChange(module.module_name, "view_permission")
                                                  }
                                                >
                                                  <span className="pill-icon">
                                                    {selectedModules[module.module_name]?.view_permission ? <FaCheck className="perm-icon" /> : <FaTimes className="perm-icon off" />}
                                                  </span>
                                                </div>
                                                </td>
                        <td>
                          <Form.Check
                            type="checkbox"
                            className="shadow-checkbox"
                            checked={
                              selectedModules[module.module_name]?.read &&
                              selectedModules[module.module_name]?.add &&
                              selectedModules[module.module_name]?.edit &&
                              selectedModules[module.module_name]?.delete &&
                              selectedModules[module.module_name]?.view_permission
                            }
                            onChange={() =>
                              handleSelectAllPermissions(module.module_name)
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  </Table>
                    )}
          

                    <Button
                      onClick={async () => {
                        submitForm();
                      }}
                      type="button"
                      variant="btn btn-primary"
                      disabled={buttonDisable}
                    >
                      Update &nbsp;
                      {buttonDisable ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        <></>
                      )}
                    </Button>
                  </form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
      <style>
        {`
          .shadow-checkbox .form-check-input {
            box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
          }
        `}
      </style>
    </>
  );
};

export default ACLSettingEdit;
